import loadable from "@loadable/component";
import React from "react";

const Nav =
  process.env.NODE_ENV === "production" || process.env.NODE_ENV === "test"
    ? () => null
    : loadable(() => import("./Nav"));

const DevNav: React.FC<{ path?: string }> =
  process.env.NODE_ENV === "production" || process.env.NODE_ENV === "test" ? () => null : (props) => <Nav {...props} />;

export default DevNav;
